import { gql } from "@apollo/client";

export const ActiveToastMessages = gql`
    query ActiveToastMessages ($filter: ToastMessageListFilter){
        toastMessageList(
            filter: $filter
        ) {
            toastMessages {
                id
                message
                fromDate
                toDate
                status
            }
        }
    }
`;
